import { Component, OnInit, OnDestroy, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { NewsService } from '../../services/news.service';
import 'dotdotdot-js'
@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.scss']
})
export class NewsDetailComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  private news: any
  language = JSON.parse(localStorage.getItem('language'))

  showNews: any
  newsTitle: string
  newsDate: string

  pageHeaderStyle = {}
  detail: any;
  newsType: string
  pdfUrl: any

  file_pdf: any
  pdfUrl_path: any

  id: any
  filesize: any;
  backgroundPath = 'assets/images/lead/default@2x.png'

  flag: any

  constructor(private route: ActivatedRoute,
    private _newsService: NewsService,
    private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.news = this.route.params.subscribe(params => {
      this._newsService.getSpecificNewsFromId(params['id']).subscribe(response => {
        
        //case news type is text
        if (this.flag == 'th') {
          if (response[0].news_type === 'text') {
            this.file_pdf = 'no'
            response[0].detail = this.htmlTransforms(response[0].detail)
            this.showNews = response
            this.newsTitle = response[0].tItle
            this.newsType = response[0].news_type
            this.newsDate = this._newsService.date_thai(response[0].publicDate)
          } else if (response[0].news_type === 'image') {
            this.file_pdf = 'no'
            this.showNews = response
            this.newsTitle = response[0].tItle
            this.newsType = response[0].news_type
            this.newsDate = this._newsService.date_thai(response[0].publicDate)
          } else if (response[0].news_type === 'pdf') {
            this.file_pdf = 'yes'
            this.pdfUrl_path = response[0].detail
            this.showNews = response
            this.pdfUrl = this.urlTransform(response[0].detail)
            this.newsTitle = response[0].tItle
            this.newsType = response[0].news_type
            this.filesize = response[0].filesize
            this.newsDate = this._newsService.date_thai(response[0].publicDate)
          }
          else if (response[0].news_type == 'vdo') {
            this.file_pdf = 'no';
            this.showNews = response;
            this.detail = response[0].detail;
            this.id = response[0].detail;
            this.newsTitle = response[0].tItle;
            this.newsType = response[0].news_type;
            this.newsDate = this._newsService.date_thai(response[0].publicDate);

          }
        } else {
          if (response[0].news_type === 'text') {
            this.file_pdf = 'no'
            response[0].detail_en = this.htmlTransforms(response[0].detail_en)
            this.showNews = response
            this.newsTitle = response[0].title_en
            this.newsType = response[0].news_type
            this.newsDate = response[0].publicDate
          } else if (response[0].news_type === 'image') {
            this.file_pdf = 'no'
            this.showNews = response
            this.newsTitle = response[0].title_en
            this.newsType = response[0].news_type
            this.newsDate = response[0].publicDate
          } else if (response[0].news_type === 'pdf') {
            this.file_pdf = 'yes'
            this.pdfUrl_path = response[0].detail_en
            this.showNews = response
            this.pdfUrl = this.urlTransform(response[0].detail_en)
            this.newsTitle = response[0].title_en
            this.newsType = response[0].news_type
            this.filesize = response[0].filesize
            this.newsDate = response[0].publicDate
          }
          else if (response[0].news_type == 'vdo') {
            this.file_pdf = 'no';
            this.showNews = response;
            this.detail = response[0].detail_en;
            this.id = response[0].detail_en;
            this.newsTitle = response[0].title_en;
            this.newsType = response[0].news_type;
            this.newsDate = response[0].publicDate;
          }
        }
        
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,
        })
      })
    })
  }

  ngOnDestroy() {
    this.news.unsubscribe();
  }

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }
}
